<app-header></app-header>
<router-outlet (activate)="onActivate()"></router-outlet>

<!-- <div *ngIf="showLoader" class="container-fluid spinner-overlay">
  <div class="row">
    <div class="col vh-100 d-flex">
      <div class="container-fluid align-self-center">
        <div class="row">
          <div class="col d-flex justify-content-center">
            <img src="assets/images/spin.gif" width="200" height="200" alt=""/>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col d-flex justify-content-center">
            <b>Loading application, please wait...</b>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div> -->

<!-- Dialogs -->

<div class="divPopUp" *ngIf="openIdlePopup === true">
  <uitk-dialog [(showModal)]="idlePopUpDialogModal.show" [closeBtn]="false">
    <uitk-dialog-header>
      <h4 class="modal-title pull-left">
        You Have Been Idle!
      </h4>
    </uitk-dialog-header>
    <uitk-dialog-content>
      <span>
        {{idleState}}
      </span>
    </uitk-dialog-content>
    <uitk-dialog-actions>
      <button class="uitk-c-button uitk-c-button--default uitk-u-margin--xxs" (click)="signOut()">
        Sign Out
      </button>
      <button class="uitk-c-button uitk-c-button--ghost uitk-u-margin--xxs" (click)="stay()">
        Stay
      </button>
    </uitk-dialog-actions>
  </uitk-dialog>
</div>